import React, {useState, useEffect, useContext} from "react";
import {UserContext} from "../common/UserContext";
import axios from "../common/axios";
import ListItem from "../common/ListItem";
import CircularLoader from "../common/CircularLoader";

const Brands = props => {
    const {user, setUser} = useContext(UserContext);
    const [brands, setBrands] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const loadBrands = () => {
        axios.get('/web/ui/session/public/brands')
            .then(response => {
                setBrands(response.data);
                setLoading(false);
            });
    };

    useEffect(() => {
        if(user.brandCodes !== undefined && user.brandCodes.length > 0) {
            loadBrands();
        } else {
            setLoading(false);
        }
    }, [user]);

    if(brands == undefined && brands.length == 0) {
        return null;
    }

    if(isLoading) {
        return <CircularLoader pageCentered={false}/>
    }

    return (
        <ul className={'ch-list'}>
            {brands.map((brand, index) => {
                const handleOnClick = () => {
                    window.location = '/dashboard/changeBrand.action?brandCode=' + brand.brandCode;
                }

                return <ListItem isDisclosureItem={true} key={brand.brandId} onClick={handleOnClick} active={user.brandCode == brand.brandCode}>
                    {brand.brandName}
                </ListItem>
            })}
        </ul>
    )
}

export default Brands;